import { useModel as _useModel, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "bdy" };
const _hoisted_2 = { class: "st" };
const _hoisted_3 = { class: "wc" };
const _hoisted_4 = { class: "sl" };
const _hoisted_5 = { class: "is" };
const _hoisted_6 = { class: "smp" };
const _hoisted_7 = { class: "alt" };
const _hoisted_8 = { class: "pbs" };
const _hoisted_9 = ["value"];
const _hoisted_10 = ["value"];
const _hoisted_11 = ["value"];
const _hoisted_12 = ["value"];
const _hoisted_13 = ["value"];
const _hoisted_14 = { class: "trz" };
const _hoisted_15 = ["value"];
const _hoisted_16 = ["value"];
const _hoisted_17 = ["value"];
const _hoisted_18 = ["value"];
const _hoisted_19 = ["value"];
const _hoisted_20 = ["value"];
const _hoisted_21 = ["value"];
import SubmitButton from '@/components/buttons/SubmitButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SongRegConfirmAndSave',
    props: {
        "songRegistration": {},
        "songRegistrationModifiers": {},
    },
    emits: ["update:songRegistration"],
    setup(__props) {
        const songRegistration = _useModel(__props, 'songRegistration');
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, "Title:" + _toDisplayString(songRegistration.value?.songTitle), 1),
                        _createElementVNode("div", _hoisted_3, "Work Content:" + _toDisplayString(songRegistration.value?.workContent), 1),
                        _createElementVNode("div", _hoisted_4, "Language:" + _toDisplayString(songRegistration.value?.songLanguage), 1),
                        _createElementVNode("div", _hoisted_5, "ISWC:" + _toDisplayString(songRegistration.value?.ISWC), 1),
                        _createElementVNode("div", _hoisted_6, "Samples? - " + _toDisplayString(songRegistration.value?.samples), 1),
                        _createElementVNode("div", _hoisted_7, "Alt Title:" + _toDisplayString(songRegistration.value?.altTitle), 1),
                        _createElementVNode("div", _hoisted_8, [
                            _cache[0] || (_cache[0] = _createTextVNode("Publishers: ")),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(songRegistration.value?.publisherInfo, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    class: "pbsg",
                                    key: index
                                }, [
                                    (_openBlock(), _createElementBlock("input", {
                                        type: "text",
                                        readonly: "",
                                        key: index + '-' + item,
                                        value: 'Pub Name: ' + item.pubName
                                    }, null, 8, _hoisted_9)),
                                    (_openBlock(), _createElementBlock("input", {
                                        type: "text",
                                        readonly: "",
                                        key: index + '-' + item,
                                        value: 'IP Number: ' + item.ipNumber
                                    }, null, 8, _hoisted_10)),
                                    (_openBlock(), _createElementBlock("input", {
                                        type: "text",
                                        readonly: "",
                                        key: index + '-' + item,
                                        value: 'Capacity:' + item.capacity
                                    }, null, 8, _hoisted_11)),
                                    (_openBlock(), _createElementBlock("input", {
                                        type: "text",
                                        readonly: "",
                                        key: index + '-' + item,
                                        value: (item.controlled) ? 'Controlled:yes' : 'Controlled:no'
                                    }, null, 8, _hoisted_12)),
                                    (_openBlock(), _createElementBlock("input", {
                                        type: "text",
                                        readonly: "",
                                        key: index + '-' + item,
                                        value: 'Affiliation: ' + item.affiliation
                                    }, null, 8, _hoisted_13))
                                ]));
                            }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                            _cache[1] || (_cache[1] = _createTextVNode("Writers ")),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(songRegistration.value?.writerInfo, (item, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    class: "trzg",
                                    key: index
                                }, [
                                    (_openBlock(), _createElementBlock("input", {
                                        type: "text",
                                        readonly: "",
                                        key: index + '-' + item,
                                        value: 'First Name: ' + item.firstName
                                    }, null, 8, _hoisted_15)),
                                    (_openBlock(), _createElementBlock("input", {
                                        type: "text",
                                        readonly: "",
                                        key: index + '-' + item,
                                        value: 'Last Name: ' + item.lastName
                                    }, null, 8, _hoisted_16)),
                                    (_openBlock(), _createElementBlock("input", {
                                        type: "text",
                                        readonly: "",
                                        key: index + '-' + item,
                                        value: 'IP Number: ' + item.ipNumber
                                    }, null, 8, _hoisted_17)),
                                    (_openBlock(), _createElementBlock("input", {
                                        type: "text",
                                        readonly: "",
                                        key: index + '-' + item,
                                        value: 'Capacity:' + item.capacity
                                    }, null, 8, _hoisted_18)),
                                    (_openBlock(), _createElementBlock("input", {
                                        type: "text",
                                        readonly: "",
                                        key: index + '-' + item,
                                        value: (item.controlled) ? 'Controlled:yes' : 'Controlled:no'
                                    }, null, 8, _hoisted_19)),
                                    (_openBlock(), _createElementBlock("input", {
                                        type: "text",
                                        readonly: "",
                                        key: index + '-' + item,
                                        value: 'Share:' + item.share + '%'
                                    }, null, 8, _hoisted_20)),
                                    (_openBlock(), _createElementBlock("input", {
                                        type: "text",
                                        readonly: "",
                                        key: index + '-' + item,
                                        value: 'Affiliation: ' + item.affiliation
                                    }, null, 8, _hoisted_21))
                                ]));
                            }), 128))
                        ])
                    ])
                ]),
                _createVNode(SubmitButton, null, {
                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                        _createTextVNode("Save")
                    ])),
                    _: 1
                })
            ], 64));
        };
    }
});
